export enum ThreatResourceType {
    Projects = 'projects',
    Functions = 'functions',
    Sites = 'sites',
    Deployments = 'deployments',
    Databases = 'databases',
    Buckets = 'buckets',
    Files = 'files',
    Users = 'users',
    Mails = 'mails',
    Platforms = 'platforms',
}
